import { useQuery } from "@tanstack/react-query";
import { getMinistryContexts, type MinistryContext } from "@/api/authorization";
import { useAuth } from "@/features/auth/hooks/useAuth";

export type MinistryNavigationEntry = {
  id: string;
  label: string;
  to: string;
};

// Register only implemented workspaces. A ministry's existence alone does not
// create an operational destination; the API supplies authorized contexts only.
const workspaces: { key: string; to: string; supports: (context: MinistryContext) => boolean }[] = [
  { key: "youth", to: "/youth", supports: context => context.is_youth_church },
];

export function useMinistryNavigation(): MinistryNavigationEntry[] {
  const { churchId } = useAuth();
  const query = useQuery({
    queryKey: ["ministry-contexts", churchId],
    queryFn: () => getMinistryContexts(churchId!),
    enabled: !!churchId,
  });

  if (!churchId || query.isError) return [];

  return (query.data ?? []).flatMap(context =>
    workspaces.filter(workspace => workspace.supports(context)).map(workspace => ({
      id: `${workspace.key}:${context.ministry_id}`,
      label: context.name,
      to: workspace.to,
    })),
  );
}
